import { createApi } from '@reduxjs/toolkit/query/react';
import { waPlatformQuery } from './baseQueries';

export interface AggregatorError {
  AggregatorErrorId: number;
  AggregatorId: number;
  StatusCode: string;
  Name: string;
  DefaultMessage: string;
  StatusType: string;
  CustomMessage: string;
  ActionType: string;
}

export interface ErrorsResponse {
  Data: AggregatorError[];
  Total: number;
}

export const errorsApi = createApi({
  reducerPath: 'errorsApi',
  baseQuery: waPlatformQuery,
  endpoints: (builder) => ({
    getErrorsByAggregator: builder.query<
      ErrorsResponse,
      {
        sort?: string;
        page?: number;
        pageSize?: number;
        group?: string;
        filter?: string;
        aggregatorId?: number;
      }
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params.sort) searchParams.append('sort', params.sort);
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.pageSize)
          searchParams.append('pageSize', params.pageSize.toString());
        if (params.group) searchParams.append('group', params.group);
        if (params.filter) searchParams.append('filter', params.filter);
        if (params.aggregatorId)
          searchParams.append('aggregatorId', params.aggregatorId.toString());

        return {
          url: `/Administrator/Index/GetErrorsByAggregator?${searchParams.toString()}`,
          method: 'POST',
        };
      },
    }),
  }),
});
export const { useGetErrorsByAggregatorQuery } = errorsApi;
